var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBellFilled = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.174 22.823a2.263 2.263 0 0 0 2.257-2.256H6.918a2.256 2.256 0 0 0 2.256 2.256m6.77-6.77v-5.64c0-3.464-1.85-6.363-5.077-7.13v-.768A1.69 1.69 0 0 0 9.174.823a1.69 1.69 0 0 0-1.692 1.692v.768c-3.238.767-5.077 3.655-5.077 7.13v5.64L.15 18.31v1.128H18.2V18.31z"
  })));
};
export default SvgBellFilled;